import PropTypes from 'prop-types';
import React from 'react';
import { Card, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ImageLoader = ({ src, className, ...props }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {src ?
        <Image className={className} src={src} {...props} />
        : <Card className="d-flex align-items-center justify-content-center"
          style={{
            height: '100%',
          }}>
          {t('influencers.common.no_content')}
        </Card>
      }
    </React.Fragment>
  )
};

ImageLoader.propTypes = {
  src: PropTypes.string,
  className: PropTypes.any
};

ImageLoader.defaultProps = {
  src: null,
  className: ''
};

export default React.memo(ImageLoader);